"use client"

import { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { TextField, Button, Container, Typography, Paper, CircularProgress, makeStyles, Box } from "@material-ui/core"
import { VpnKey as KeyIcon, Lock as LockIcon } from "@material-ui/icons"
import firebase from "../firebase"

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "0.5rem",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    border: "1px solid #e5e7eb",
    backgroundColor: "white",
    animation: "$fadeIn 0.5s ease-out",
  },
  icon: {
    fontSize: "3rem",
    color: "#6366f1",
    marginBottom: theme.spacing(2),
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    padding: theme.spacing(1.5, 0),
    backgroundColor: "#6366f1",
    "&:hover": {
      backgroundColor: "#4f46e5",
    },
    borderRadius: "0.5rem",
    transition: "all 0.3s ease",
    textTransform: "none",
    fontSize: "1rem",
  },
  title: {
    marginBottom: theme.spacing(3),
    color: "#1f2937",
    fontWeight: 700,
  },
  subtitle: {
    marginBottom: theme.spacing(3),
    color: "#6b7280",
  },
  "@keyframes fadeIn": {
    from: { opacity: 0, transform: "translateY(10px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  logoContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(3),
  },
  logoText: {
    marginLeft: theme.spacing(1),
    fontWeight: 700,
    color: "#6366f1",
  },
}))

function Login() {
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(true)
  const history = useHistory()
  const classes = useStyles()

  useEffect(() => {
    // Verificar si el usuario ya está autenticado
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // Usuario ya autenticado, redirigir al dashboard
        history.push("/dashboard")
      } else {
        // No hay usuario autenticado, mostrar formulario de login
        setLoading(false)
      }
    })

    // Limpiar el listener cuando el componente se desmonte
    return () => unsubscribe()
  }, [history])

  const handleLogin = async (e) => {
    e.preventDefault()
    setError(null)
    setLoading(true)

    try {
      await firebase.auth().signInWithEmailAndPassword(email, password)
      // No es necesario redirigir aquí, el useEffect se encargará de eso
    } catch (error) {
      console.error("Error signing in: ", error)
      setError(error.message)
      setLoading(false)
    }
  }

  if (loading) {
    return (
      <Container
        maxWidth="xs"
        style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}
      >
        <CircularProgress style={{ color: "#6366f1" }} />
      </Container>
    )
  }

  return (
    <Container maxWidth="xs" style={{ marginTop: "5rem" }}>
      <Paper className={classes.paper}>
        <Box className={classes.logoContainer}>
          <KeyIcon className={classes.icon} />
          <Typography variant="h5" className={classes.logoText}>
            Dynamic QR
          </Typography>
        </Box>
        <Typography variant="h4" className={classes.title}>
          Welcome Back
        </Typography>
        <Typography variant="body1" className={classes.subtitle}>
          Sign in to access your QR code dashboard
        </Typography>
        {error && (
          <Typography color="error" gutterBottom style={{ width: "100%", textAlign: "center", marginBottom: "1rem" }}>
            {error}
          </Typography>
        )}
        <form className={classes.form} onSubmit={handleLogin}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={loading}
            startIcon={loading ? <CircularProgress size={20} /> : <LockIcon />}
          >
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </form>
      </Paper>
    </Container>
  )
}

export default Login

